import { DELIVERY_METHODS_DICTIONARY } from "@components/commerce/checkout/types";
import type { ShippingPrice } from "@interfaces/storefront-api";

export function getDeliveryMethodKey(key: string): string {
    const hostName = process.env.NEXT_PUBLIC_HOSTNAME;
    return (
        DELIVERY_METHODS_DICTIONARY[hostName]?.find((entry) => entry.key === key)?.marketKey ?? key
    );
}

export const findClickAndCollect = (deliveryMethods: ShippingPrice[]) => {
    return (
        deliveryMethods?.find((method) => method.key === "CC") || {
            key: "CC",
            name: "",
        }
    );
};

export const findHomeDelivery = (deliveryMethods: ShippingPrice[]) => {
    return (
        deliveryMethods?.find((method) => {
            return method.orderType === "HD";
        }) || {
            key: "HD",
            name: "",
        }
    );
};
